/**
 * Dependencies
 */
import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import classes from '@nerdwallet/base-styles/classes';
import { Link } from '@nerdwallet/currency';

// Local Components
import Hero from '../components/hero/hero';
import CCTool from '../components/cc-tool/cc-tool';
import CCBest from '../components/cc-best/cc-best';
import Smorgasbord from '../components/smorgasbord/smorgasbord';
import ReasonsToBelieve from '../components/reasons-to-believe/reasons-to-believe';
import AccountModule from '../components/account-module/account-module';
import Security from '../components/security/security';
import Safe from './safe';

// Other Local Dependencies
import {
  heroNavCopy,
  ccToolContent,
  smorgasbordContent,
  securityContent,
  ccBestContent,
  accountModuleContent,
} from '../lib/front-page-content';

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';

  return (
    <div>
      <DocumentTitle title={documentTitle} />
      <div>
        <div>
          <div className="front-page-gradient">
            <Hero {...heroNavCopy} />
            <AccountModule {...accountModuleContent} />
          </div>
          <CCTool {...ccToolContent} />
        </div>
        <Safe>
          <Smorgasbord
            {...smorgasbordContent}
            className={classes(['margin-bottom-4', 'margin-bottom-0--wide'])}
          />
        </Safe>
        <ReasonsToBelieve
          eyebrow="You got this"
          imageUrl="https://www.nerdwallet.com/cdn/homepage/images/nw-hp-rtb-destkop-1.jpg"
          bullets={[
            {
              title: 'Expert info',
              content:
                'Our objective and award-winning editorial team of 80+ Nerds make even the most complicated money questions and topics simple to understand.',
            },
            {
              title: 'Helpful tools',
              content:
                'Side-by-side comparisons, smart calculators and straightforward simulators help you make sense of your options.',
            },
            {
              title: 'Tailored insights',
              content:
                "Tell us more about you and we'll recommend things like the best credit card for your spending habits, simple ways to up your credit score and more.",
            },
          ]}
        />
        <CCBest {...ccBestContent} />
        <Security
          {...securityContent}
          securityText={
            <Fragment>
              We always have your security in mind. Rest easy knowing your data
              is encrypted for enhanced protection.{' '}
              <Link href="https://www.nerdwallet.com/l/security?trk=hp_security_infosecure&trk_app=front-page&trk_copy=infosecure">
                Learn more
              </Link>
              .
            </Fragment>
          }
        />
      </div>
    </div>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';

FrontPage.propTypes = {};

export default FrontPage;
